module.exports = __webpack_public_path__ + "img/device-bg3.80b5a805.png";